module.exports = __webpack_public_path__ + "img/shenhe-sp.6d342a82.png";